import {
  EntityAboutCard,
  EntityHasSubcomponentsCard,
  EntityLinksCard,
  EntitySwitch,
  isComponentType,
} from "@backstage/plugin-catalog";
import { EntityCatalogGraphCard } from "@backstage/plugin-catalog-graph";
import { Grid } from "@material-ui/core";

import { EntityAboutSaaSCard } from "../cards/EntityAboutSaaSCard";
import { EntityScaffolderCard } from "../cards/EntityScaffolderCard";
import { EntityUpdateSystemCard } from "../cards/EntityUpdateSystemCard";

import entityWarningContent from "./entityWarningContent";

const isSaaSComponent = (entity: any) =>
  isComponentType("external-service")(entity) &&
  Boolean(entity.metadata?.tags?.includes("saas"));

export default (
  <Grid container spacing={3} alignItems="stretch">
    {entityWarningContent}
    <Grid item md={6}>
      <EntitySwitch>
        <EntitySwitch.Case if={isSaaSComponent}>
          <EntityAboutSaaSCard variant="gridItem" />
        </EntitySwitch.Case>
        <EntitySwitch.Case>
          <EntityAboutCard />
        </EntitySwitch.Case>
      </EntitySwitch>
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityCatalogGraphCard height={400} />
    </Grid>

    <Grid item md={4} xs={12}>
      <EntityLinksCard />
    </Grid>
    <Grid item md={4} xs={12}>
      <EntityScaffolderCard />
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityUpdateSystemCard />
    </Grid>
    <Grid item md={4} xs={12}>
      <EntityHasSubcomponentsCard variant="gridItem" />
    </Grid>
  </Grid>
);
